import styled from "styled-components";

export const HeaderMainDiv = styled.div`
  margin: 15px 0 10px;
  width: 100%;
  display: flex;
  @media (max-width: 910px) {
    display: none;
  }
`;
export const HeaderDiv = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: 860px;
  display: flex;
  align-items: flex-end;
  position: relative;
`;
export const Title = styled.p`
  padding: ${({ padding }) => padding && padding};
  width: ${({ width }) => width && width};
  font-size: 14px;
  font-weight: 600;
  color: #808080;
  text-align: ${({ textAlign }) => textAlign && "center"};
`;
